"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleParamsError = void 0;
const common_1 = require("@finley-technologies/common");
const handleParamsError = (error, params) => {
    const { prefix } = params;
    if (common_1.typeguards.isFinleyErrorType(error)) {
        return [`${prefix}: ${error.externalMessage || error.message}`];
    }
    if (common_1.typeguards.isErrorType(error)) {
        return [`${prefix}: ${error.message}`];
    }
    return [`${prefix}: Unknown error, please seek technical assistance.`];
};
exports.handleParamsError = handleParamsError;
//# sourceMappingURL=utils.js.map